import React, { ReactElement } from 'react';
import EmptyState from '@atlaskit/empty-state';
import { BuildingImage } from '../DownForMaintenanceView/BuildingImage';
import { useFeatureFlags } from '../FeatureFlagProvider/FeatureFlagProvider';

export function DownForMaintenanceWrapper(props: { children: ReactElement }) {
  const featureFlags = useFeatureFlags();

  if (featureFlags['pc-frontend-down-for-maintenance']) {
    return (
      <EmptyState
        renderImage={() => <BuildingImage />}
        header='Down For Maintenance'
        description='Preferences Center is currently down for maintenance. Please try again in a few minutes.'
      />
    );
  } else {
    return props.children;
  }
}
